import { render } from "./OtherPaymentsInvoice.vue?vue&type=template&id=630b18e3&scoped=true"
import script from "./OtherPaymentsInvoice.vue?vue&type=script&lang=js"
export * from "./OtherPaymentsInvoice.vue?vue&type=script&lang=js"

import "./OtherPaymentsInvoice.vue?vue&type=style&index=0&id=630b18e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630b18e3"]])

export default __exports__